import * as R from 'ramda';
import { useState, useEffect } from 'react';
// helpers/constants
import * as G from '../helpers';
import * as GC from '../constants';
// utilities
import { sendRequest } from '../utilities/http';
import endpointsMap from '../utilities/endpoints';
//////////////////////////////////////////////////

export const useAsyncGetConfigs = (props: Object) => {
  const { names, branchGuid, initialValues, shouldNotGetConfigs, createOptionsFromDropdowns } = props;

  const [asyncConfigs, setAsyncConfigs] = useState(R.or(initialValues, {}));

  useEffect(() => {
    const handleGetConfigs = async () => {
      if (shouldNotGetConfigs) return;

      const options = {
        params: {
          names: R.join(',', names),
          [GC.FIELD_BRANCH_GUID]: R.or(branchGuid, G.getAmousCurrentBranchGuidFromWindow()),
        },
      };

      const res = await sendRequest('get', endpointsMap.branchConfigsEndpoint, options);

      const { data, status } = res;

      if (G.isResponseSuccess(status)) {
        const mapped = G.mapConfigValuesByName(data);

        const dropdownsOptions = createOptionsFromDropdowns ? R.map(
          ({ options }: Object) => G.getOptionsFromConfigValueByParentGuidOrGuid(options),
          R.pathOr({}, ['dropdowns'], mapped),
        ) : {};

        setAsyncConfigs({ ...mapped, dropdownsOptions });
      } else {
        G.handleFailResponseSimple(res, false, 'useAsyncGetConfigs');
      }
    };

    handleGetConfigs();
  }, [shouldNotGetConfigs]);

  return asyncConfigs;
};
